module.exports = __webpack_public_path__ + "img/card_230410681.6819146d.jpg";